import UrlUtil from "../../utils/urlUtil"
import {Logger} from '../../utils/logger'
import * as types from '../actionTypes'
import {iodtFormat} from "../../utils/util"

let moment = null
const momentPromise = import(/* webpackChunkName: "momentTimezone" */ "moment-timezone") //.then(module => moment = module.default)
let axios = null
const axiosPromise = import(/* webpackChunkName: "axios" */ 'axios')

const url = new UrlUtil('/api/maint')

const waitForImports = async () => {
  moment = (await momentPromise).default
  axios = (await axiosPromise).default
}

export const logout = () => {
  return () => {
    axios.get('/api/frm/sso/logout')
    .then((response) => {
      if (!response || response.status !== 200) {
        console.error('logout error', response)
      } else {
        window.open(response.data.data, "_self")
      }
    }).catch((error) => {
      console.error('logout error', error)
    })
  }
}

export const logError = (err) => {
  return (dispatch, getState) => {
    console.log('Error: ', JSON.stringify(err))
    if (getState().app.hasError) {
      // already in an error state, dont re-dispatch and cause an infinite loop
      return
    }
    if (err.config) {
      Logger.log(
          err.config.url + ' failed with ' + err.response.status + '\n' + JSON.stringify(err.response.data))
    } else {
      Logger.log(err.stack)
    }
    dispatch({type: types.SET_ERROR})
    throw(err)
  }
}

export const clearError = () => {
  return (dispatch) => {
    dispatch({type: types.CLEAR_ERROR})
  }
}

export const initializeApp = (actions) => {
  return (dispatch) => {
    actions.forEach((action) => {
      dispatch(action)
    })
  }
}

export const getMaintDates = () => {
  return async (dispatch) => {
    if (!moment || !axios) {
      await waitForImports()
    }
    const result = await axios.get(url.makeUrl(['getDates']))
    if (result && result.data) {
      const start = moment.utc(result.data.start, iodtFormat)
      const end = moment.utc(result.data.end, iodtFormat)
      dispatch({type: types.DOWNTIME_DATES, start: start, end: end})
    }
  }
}

export const setMocCheckResponse = (mocCheckResponse) => ({
  type: types.SET_MOC_CHECK_RESPONSE,
  payload: mocCheckResponse
})